export enum UpgradeHivRnaDisplay {
  None = 'none',
  TitleOnly = 'title-only',
  TitleAndItem = 'title-and-item',
}
